"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSocialMedia = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_social_media_1 = require("@hotelplan/components.common.social-media");
const SocialMediaWrap = styled_components_1.default.div(({ theme: { colors, media, space } }) => ({
    border: '1px solid',
    borderColor: colors.borderColor,
    alignItems: 'center',
    marginBottom: space[3],
    [media.tablet]: {
        border: 'none',
        display: 'flex',
        flex: '1',
        marginBottom: 0,
    },
}));
const SocialMediaItemTitle = styled_components_1.default.h4(({ theme: { colors, space, media, fontSizes } }) => ({
    borderBottom: '1px solid',
    borderColor: colors.lightGreySecond,
    padding: `${space[2]} ${space[4]}`,
    fontWeight: 'bold',
    fontSize: '18px',
    [media.tablet]: {
        borderBottom: 'none',
        padding: `0 ${space[4]}`,
        fontWeight: 'normal',
        fontSize: fontSizes[2],
        color: colors.secondary,
    },
}));
const FooterSocialMedia = ({ items = [], className, }) => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    return (react_1.default.createElement(SocialMediaWrap, { className: className },
        react_1.default.createElement(SocialMediaItemTitle, { className: "social-media-title" }, t('social.follow.heading')),
        react_1.default.createElement(components_common_social_media_1.SocialMedia, { items: items })));
};
exports.FooterSocialMedia = FooterSocialMedia;
//# sourceMappingURL=FooterSocialMedia.js.map